import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaEnvelope,
  FaBell,
  FaClipboardList,
  FaSearch,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { useUser } from "../../context/UserContext";
const Navbar = React.forwardRef(
  (
    {
      toggleSidebar,
      notificationIconRef,
      setShowNotificationPane,
      accountIconRef,
      setShowAccountPane,
      profileImageUrl,
    },
    ref
  ) => {
    const [searchTerm, setSearchTerm] = useState("");
    const { totalUnverifiedWorkerCount, getUnverifiedWorkerUsersAndCounts } =
      useUser();
    const isMobile = useMediaQuery({ maxWidth: 768 });

    useEffect(() => {
      getUnverifiedWorkerUsersAndCounts();
    }, [getUnverifiedWorkerUsersAndCounts]);

    const handleNotificationClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (notificationIconRef.current) {
        const rect = notificationIconRef.current.getBoundingClientRect();
        setShowNotificationPane((prevState) => {
          if (prevState.show) {
            return { ...prevState, show: false };
          } else {
            return {
              show: true,
              top: isMobile ? rect.top : rect.bottom,
              left: rect.left + rect.width / 2,
              bottom: isMobile ? window.innerHeight - rect.top : null,
              iconWidth: rect.width,
            };
          }
        });
      }
    };

    const handleAccountClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (accountIconRef.current) {
        const rect = accountIconRef.current.getBoundingClientRect();
        setShowAccountPane((prevState) => ({
          show: !prevState.show,
          top: isMobile ? "auto" : rect.bottom + window.scrollY,
          bottom: isMobile ? window.innerHeight - rect.top : "auto",
          left: isMobile ? "auto" : rect.right - 250,
        }));
      }
    };

    const renderNavbarIcons = () => (
      <div className="navbar-icons-container">
        <div className="navbar-icons">
          <Link className="navbar-icon">
            <div className="notification-icon-wrapper">
              <FaHome />
            </div>
            <span>Home</span>
          </Link>
          <Link className="navbar-icon">
            <div className="notification-icon-wrapper">
              <FaClipboardList />
            </div>
            <span>Jobs</span>
          </Link>
          <Link
            className="navbar-icon"
            onClick={handleNotificationClick}
            ref={notificationIconRef}
          >
            <div className="notification-icon-wrapper">
              <FaBell />
              {totalUnverifiedWorkerCount > 0 && (
                <div className="notification-badge">
                  {totalUnverifiedWorkerCount > 99
                    ? "99+"
                    : totalUnverifiedWorkerCount}
                </div>
              )}
            </div>
            <span>Notifications</span>
          </Link>

          <Link className="navbar-icon">
            <div className="notification-icon-wrapper">
              <FaEnvelope />
            </div>
            <span>Inbox</span>
          </Link>
        </div>
        <div className="account-icon-wrapper">
          <Link
            className={`navbar-icon account-icon ${isMobile ? "mobile" : ""}`}
            onClick={handleAccountClick}
            ref={accountIconRef}
          >
            <img
              src={profileImageUrl}
              alt="Profile"
              className="profile-image"
            />
            <span>
              Account
              {isMobile ? (
                <FaChevronUp className="chevron-icon" />
              ) : (
                <FaChevronDown className="chevron-icon" />
              )}
            </span>
          </Link>
        </div>
      </div>
    );

    return (
      <>
        <nav className="dashboard-navbar" ref={ref}>
          <div className="dashboard-navbar-logo">
            <a href="/">
              <img
                src="/images/dashboard_logo.png"
                alt="Logo"
                className="logo-image"
              />
            </a>
          </div>

          <div className="dashboard-navbar-controls">
            <div className="search-container">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            {!isMobile && renderNavbarIcons()}
          </div>

          <div className="dashboard-navbar-logout">
            <button className="hamburger-menu" onClick={toggleSidebar}>
              ☰
            </button>
          </div>
        </nav>

        {isMobile && <div className="bottom-navbar">{renderNavbarIcons()}</div>}
      </>
    );
  }
);

export default Navbar;
